// extracted by mini-css-extract-plugin
module.exports = {"legalFooterContainer":"mobile-app-legal-footer_legalFooterContainer__43ZgU"};